<script lang="ts">
	//Hooks
	import { beforeUpdate, createEventDispatcher } from 'svelte';
	//Components
	import { CardGrid, SelectCard } from '@Shelly/shelly-design-system';
	//Helpers
	import { load_image_from, real_id } from '../../../../helpers/interface_helpers';
	import { readDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let filteredDevices, isThermostat, deviceActions;

	const variant = isThermostat ? 'radio' : 'checkbox';
	const dispatch = createEventDispatcher();
	let disabled = {};

	/**
	 * @function handleSelection is а simply selection of devices from generated list
	 */
	const handleSelection = async (device) => {
		let selectedDevices = deviceActions.selectedDevices;
		if (deviceActions.mode === 'sensor') {
			let selected = deviceActions.selectedDevices.includes(device.id);
			if (selected) {
				const index = deviceActions.selectedDevices.indexOf(device.id);
				selectedDevices.splice(index, 1);
			} else {
				selectedDevices.push(device.id);
			}
		} else {
			selectedDevices = [device.id];
		}

		dispatch('update', { selectedDevices });
	};

	/**
	 * @method beforeUpdate dynamically enable or disable device selection based on the selection length condition: allow up to 5 devices for motion sensors and 1 device for TRV temperature or window reports.
	 */
	beforeUpdate(() => {
		filteredDevices.forEach((device, index) => {
			const category = device.category;
			disabled[index] =
				!readDeviceStatus(real_id(device.id))?.online ||
				(deviceActions.mode === 'sensor' &&
					deviceActions.selectedDevices.length >= (category !== 'sensor' ? 5 : 1) &&
					!deviceActions.selectedDevices.includes(device.id));
		});
	});
</script>

<CardGrid gridGap="s" lg={290} sm={270} noPaddingBottom>
	{#each filteredDevices as device, i}
		<SelectCard
			cardBgColor={$showNewLayout ? 'color-1' : undefined}
			type="horizontal"
			title={device.name}
			selected={deviceActions.selectedDevices.includes(device.id)}
			image={device.image ? load_image_from(device.image, device?.server) : undefined}
			backgroundColor={device.backgroundColor}
			{variant}
			class="width-full"
			disabled={disabled[i]}
			on:click={() => handleSelection(device)}
		/>
	{/each}
</CardGrid>
